enum WIDGET_SIZE {
  fixed = 'fixed',
  fixed_custom = 'fixed_custom',
  responsive = 'responsive',
}

export default WIDGET_SIZE;
